import { render, staticRenderFns } from "./environment.vue?vue&type=template&id=3cb871ef&scoped=true&"
var script = {}
import style0 from "./environment.vue?vue&type=style&index=0&id=3cb871ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb871ef",
  null
  
)

export default component.exports